import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

// PrimeNG modules
import { CardModule } from 'primeng/card';
import { SkeletonModule } from 'primeng/skeleton';
import { PaginatorModule } from 'primeng/paginator';
import { ButtonModule } from 'primeng/button';

// Components
import { NotificationListComponent } from './notification-list/notification-list.component';
import { NotificationItemComponent } from './notification-item/notification-item.component';
import { NotificationsRoutingModule } from './notifications-routing.module';
import { NotificationPageItemComponent } from './notification-page-item/notification-page-item.component';

@NgModule({
  declarations: [
    NotificationListComponent,
    NotificationItemComponent,
    NotificationPageItemComponent
  ],
  imports: [
    CommonModule,
    TranslateModule,
    NotificationsRoutingModule,
    // PrimeNG
    CardModule,
    SkeletonModule,
    PaginatorModule,
    ButtonModule
  ],
  exports: [
    NotificationItemComponent // Export for use in other modules (e.g., dropdown)
  ]
})
export class NotificationsModule {}
